var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wine-club main-container",
      attrs: { id: "somnambulist-ui" },
    },
    [
      _vm.showJoin
        ? _c("join")
        : _c("order", {
            on: {
              cancelOrder: function ($event) {
                return _vm.$emit("cancelOrder")
              },
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }